<template>
	<PageLoading :is-loading="isLoading"></PageLoading>
	<SideComponent @scrollto="scroll"></SideComponent>
	<div class="container" ref="viewBox">		
		<div class="header-container">
			<HeaderVR />
			<!-- <div class="bigimg-container" v-if="banner.length>0">
				<Swiper :list="banner"/>
			</div> -->
		</div>
		<div id="content" class="content" ref="content">
			<!-- <Loading :is-loading="isListLoading"></Loading> -->			
			<!-- <LivePlayerDemo msg="LivePlayer.js H5直播点播播放器演示" /> -->
			 <!-- <VideoPlayer :options="playerOptions" />  -->
			 <h1>直播节目</h1>
			 <!-- <div style="width:512px;height:300px;margin:auto">
		        <LivePlayer videoUrl="rtmp://livepull.qtv.com.cn/live/b9a84e6e54697babdab3e109321426d7" live="true" stretch="true"/>
		    </div> -->
			 <!-- <live-player video-url="rtmp://livepull.qtv.com.cn/live/b9a84e6e54697babdab3e109321426d7" live="true" stretch="true"></live-player> -->
			 <video ref="videoPlayer" class="video-js vjs-big-play-centered" controls style="width:80%;height:80%;object-fit:contain;"></video>
   			 <!-- <video id="my-video"
	            class="video-js vjs-default-skin"
	            controls
	            preload="auto"
	            
	        >
	            <source src="" type="application/x-mpegURL" />
	        </video> -->
		</div>
		<div style="display:flex;justify-content:center;align-items: center;width:100%;padding:20px 0;">
			<el-button type="danger" plain @click="startConversion">开始</el-button>
   			<el-button type="success" plain @click="stopConversion">停止</el-button>
		</div>
		<Footer/>

	</div>
	
</template>

<script>
	import rtmp from './rtmp_controller';
	export default rtmp;
</script>

<style src="@/assets/css/rtmp.css" scoped></style>
<!-- 这段全局css代码在related_news_detail.vue,subject_detail.vue,tail_detail.vue都有，而且相同。 -->
<style>
/*.ar-content .html-content p img{
	width:86%!important;
	max-width:800px;
	object-fit: contain;
}
@media screen and (max-width: 767px) {
	.ar-content .html-content p img{
		width:100%!important;
		max-width:375px!important;
		height:auto!important;
	}
}*/
</style>

